<script>
import { getHorario } from '../../utils/api'

export default {
  methods: {
    showNotificacao (type, title, msg, timeout = 5000, position = 'toast-top-right') {
      this.$toastr(type, {
        title,
        msg: `${msg} ${getHorario()}`,
        clickClose: true,
        timeout,
        position
      })
    },
    confirmBox (msg, title, callback, error, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', type = 'warning') {
      this.$confirm(msg, title, {
        confirmButtonText,
        cancelButtonText,
        type,
        cancelButtonClass: 'cancelBtn',
        confirmButtonClass: 'confirmBtn'
      })
        .then(callback)
        .catch(error)
    },
    confimBoxWithInput (msg, title, callback, error, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', type = 'warning',
      pattern = '', inputErrorMessage = 'O valor digitado está incorreto', options = {}) {
      this.$prompt(msg, title, {
        dangerouslyUseHTMLString: true,
        confirmButtonText,
        cancelButtonText,
        type,
        inputPattern: pattern,
        inputErrorMessage: inputErrorMessage,
        cancelButtonClass: 'cancelBtn',
        confirmButtonClass: 'confirmBtn',
        ...options
      })
        .then(callback)
        .catch(error)
    },
    showSuccess (msg, timeout = 5000, position = 'toast-top-right') {
      this.$toastr(this.$messages.TIPO_SUCCESS, {
        title: this.$messages.TITULO_SUCCESS,
        msg: `${msg} ${getHorario()}`,
        clickClose: true,
        timeout,
        position
      })
    },
    showError (msg, timeout = 5000, position = 'toast-top-right') {
      this.$toastr(this.$messages.TIPO_ERROR, {
        title: this.$messages.TITULO_ERROR,
        msg: `${msg} ${getHorario()}`,
        clickClose: true,
        timeout,
        position
      })
    },
    showWarning (msg, timeout = 5000, position = 'toast-top-right') {
      this.$toastr(this.$messages.TIPO_WARNING, {
        title: this.$messages.TITULO_WARNING,
        msg: `${msg} ${getHorario()}`,
        clickClose: true,
        timeout,
        position
      })
    }
  }
}
</script>
<style >

  .cancelBtn:before {
    font-family: "Font Awesome 5 Pro", sans-serif;
    font-weight: 900;
    content: "\f00d";
    width:20px;
    height:20px;
    margin-left:0px;
  }

  .cancelBtn:hover,
  .cancelBtn:focus {
    background-color: #fef0f0;
    color: #f56c6c;
    border-color: #fbc4c4;
  }

  .confirmBtn:before {
    font-family: "Font Awesome 5 Pro", sans-serif;
    font-weight: 900;
    content: "\f00c";
    width:20px;
    height:20px;
    margin-left:0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/mixins/AppNotificacao.vue